var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 24C23 22.7623 22.3752 20.8754 21.5 20.0002C20.6248 19.1251 19.903 18.667 18.6653 18.667H9.33194C8.09427 18.667 7.37517 19.1251 6.5 20.0002C5.62483 20.8754 5 22.7623 5 24",
    stroke: "#1A2D06",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9987 15.1663C16.576 15.1663 18.6654 13.077 18.6654 10.4997C18.6654 7.92235 16.576 5.83301 13.9987 5.83301C11.4214 5.83301 9.33203 7.92235 9.33203 10.4997C9.33203 13.077 11.4214 15.1663 13.9987 15.1663Z",
    stroke: "#1A2D06",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13.5,
    stroke: "#1A2D06"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileInactive);
export default __webpack_public_path__ + "static/media/ProfileInactive.c8130c3ceafe503632f546b3d8372845.svg";
export { ForwardRef as ReactComponent };